module.exports = __webpack_public_path__ + "img/ai2.8fb1ee8b.png";